import { headingSizeProp, headingTagProp, wysiwygProp } from 'utils/proptypes/modules/textProps';

import ButtonsList from 'components/buttons/ButtonsList';
import Heading from 'components/text/Heading';
import Paragraph from 'components/text/Paragraph';
import PropTypes from 'prop-types';
import React from 'react';
import Wysiwyg from 'libs/wordpress/components/Wysiwyg';
import { buttonsProp } from 'utils/proptypes/modules/buttonsProps';
import styled from 'libs/styled';

const Wrapper = styled('div')`
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    height: 100%;
`;

const Information = ({ buttons, heading, headingTag, headingSize, tag, text }) => (
    <Wrapper>
        <div>
            {heading && (
                <Heading as={headingTag} pb={['32px', null, null, '56px']} size={headingSize}>
                    {heading}
                </Heading>
            )}
            {tag && <Paragraph>{tag}</Paragraph>}
        </div>
        <div>
            {text && <Wysiwyg data={text} textComponent={props => <Paragraph size="xl" mt="24px" {...props} />} />}
            <ButtonsList pt="24px" buttons={buttons} />
        </div>
    </Wrapper>
);

Information.propTypes = {
    buttons: buttonsProp,
    heading: PropTypes.string,
    headingSize: headingSizeProp,
    headingTag: headingTagProp,
    tag: PropTypes.string,
    text: wysiwygProp,
};

export default Information;
